import React, {useEffect} from "react";
import {useSelector} from "react-redux";

import {Client} from "weed-js"


export const Checkout = ({formState, errors, setErrors}) => {

    const client = new Client();
    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user) || {};

    const [checkoutURL, setCheckoutURL] = React.useState("");

    useEffect(() => {
        if (!formState?.email) {
            setErrors({
                ...errors,
                email: "Email is a required field.",
                general: "Form state is missing email. Please go back and enter your email.",
            });
            return;
        }
        if (!formState?.stripe_product_external_id) {
            setErrors({
                ...errors,
                stripe_product_external_id: "Product is a required field.",
                general: "Please go back and select a product.",
            });
            return;
        }
        if (!formState?.stripe_price_external_id) {
            setErrors({
                ...errors,
                stripe_price_external_id: "Price is a required field.",
                general: "Please go back and select a price.",
            });
            return;
        }
        if (!formState?.organization_id) {
            setErrors({
                ...errors,
                organization_id: "Organization is a required field.",
                general: "Form state is missing organization. Please go back and select an organization.",
            });
            return;
        }

        client.stripe.api.v1().post("/checkout", {
            stripe_product_external_id: formState.stripe_product_external_id,
            stripe_price_external_id: formState.stripe_price_external_id,
            organization_id: formState.organization_id,
            store_count: formState.store_count || 1,
        }).then((response) => {
            if (response.status === 200) {
                const {checkout_url} = response.data;
                if (!checkout_url) {
                    console.error(response, response?.data);
                    setErrors({
                        ...errors,
                        general: "There was an error creating the checkout session. Please try again later.",
                    });
                    return;
                }
                setCheckoutURL(checkout_url);
                setTimeout(() => {
                    if (loggedInUser?.is_superuser) {
                        return;
                    }
                    console.log("Would redirect to: ", checkout_url);
                    window.location.href = checkout_url;
                }, 2000);
            } else {
                console.error("Error creating checkout session:", response);
                setErrors({
                    ...errors,
                    general: "There was an error creating the checkout session. Please try again later.",
                });
            }
        }).catch((error) => {
            console.error("Error creating checkout session:", error);
            setErrors({
                ...errors,
                general: "There was an error creating the checkout session. Please try again later.",
            });
        });
    }, [formState])

    if (errors.general) {
        return <div className={"error-message"}>
            <h1>Error</h1>
            <p style={{color: "red"}}>{errors.general}</p>
        </div>
    }

    console.log("Logged in user: ", loggedInUser);

    return <div>
        {loggedInUser?.is_superuser ? <h1>Not Redirecting Superusers.</h1> : <h1>Redirecting...</h1>}
        {loggedInUser?.is_superuser ? <p>But you can click <a href={checkoutURL} target={"_blank"} rel="noreferrer">here</a> if you want to go to checkout.</p> : <p>You should be redirected to check out in a moment, if not click <a target="_blank" href={checkoutURL} rel="noreferrer">here</a></p>}
    </div>
};


export default Checkout;